import { memo } from 'react';
import { Box, Button } from '@mantine/core';
import { IconAlertTriangle, IconX } from '@tabler/icons-react';

/**
 * ActionFooter component provides the "Terminate Session" button with 
 * a double-confirmation mechanism.
 */
const ActionFooter = memo(({ confirmTerminate, onTerminate }) => (
    <Box p="md" style={{ borderTop: '1px solid var(--mantine-color-dark-5)' }}>
        <Button 
            fullWidth 
            color={confirmTerminate ? "orange" : "red"} 
            variant={confirmTerminate ? "filled" : "light"}
            leftSection={confirmTerminate ? <IconAlertTriangle size={16} /> : <IconX size={16} />}
            onClick={onTerminate}
        >
            {confirmTerminate ? "Click again to Confirm Terminate" : "Terminate Session"}
        </Button>
    </Box>
));

export default ActionFooter;
